import { render, staticRenderFns } from "./ticketWallet.vue?vue&type=template&id=ff1e5598&scoped=true&"
import script from "./ticketWallet.vue?vue&type=script&lang=js&"
export * from "./ticketWallet.vue?vue&type=script&lang=js&"
import style0 from "./ticketWallet.vue?vue&type=style&index=0&id=ff1e5598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1e5598",
  null
  
)

export default component.exports